import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
const rows = [{
  format: '📖 PDF alta calidad',
  content: 'Los 6 Tomos del Sistema',
  pages: '+200 páginas'
}, {
  format: '💪 PDF imprimible',
  content: 'Los 5 Bonos completos',
  pages: '+60 páginas'
}, {
  format: '📗 PDF descargable e imprimible',
  content: 'NUEVO: 6 cuadernos prácticos: 38 sesiones adicionales, 8 dinámicas y plantillas',
  pages: '240 páginas'
}];
const checks = ['PDF de alta calidad', 'Imprimible en A4', 'Optimizado para tablet y móvil', 'Acceso inmediato sin esperas'];
export function InstantAccess() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-139" data-mp="2lndptxremfiq">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-140" data-mp="2gn84t0fn3r9m">
        <SectionTag icon="📦" data-id="element-141" data-mp="2gmg8fne7xpia">Acceso inmediato</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-142" data-mp="2cle6uzwtx1d5">
          Esto lo recibes en tu correo hoy mismo.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-143" data-mp="3afeuvm088isg">
          Material profesional descargable al instante, sin esperar envíos.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-2xl px-4 sm:px-6" data-id="element-144" data-mp="2vofqyoac6if7">
        <ScrollHintTable minWidth="520px" data-id="element-145" data-mp="30qn9jwpo8wqi">
          <table className="w-full text-left text-sm" data-id="element-146" data-mp="30niu236raekj">
            <thead data-id="element-147" data-mp="3og7v8nd7m83h">
              <tr className="border-b border-white/10 bg-white/5 text-xs uppercase tracking-wide text-muted" data-id="element-148" data-mp="3ofpnoul3k7g9">
                <th className="px-5 py-3 font-semibold" data-id="element-149" data-mp="3tdhoke3pz3wl">Formato</th>
                <th className="px-5 py-3 font-semibold" data-id="element-150" data-mp="3fdghggwv308o">Contenido</th>
                <th className="px-5 py-3 font-semibold" data-id="element-151" data-mp="3jftmt47p4w4x">Páginas</th>
              </tr>
            </thead>
            <tbody data-id="element-152" data-mp="23yte4ieovw17">
              {rows.map((row, i) => <tr key={row.content} className={i !== rows.length - 1 ? 'border-b border-white/5' : ''} data-id="element-153" data-mp="241fn8mh8ajlj" data-mpi={i}>
                  <td className="whitespace-nowrap px-5 py-4 text-white" data-id="element-154" data-mp="27ylguehej7yn">{row.format}</td>
                  <td className="px-5 py-4 text-muted" data-id="element-155" data-mp="eka8erco3aib">{row.content}</td>
                  <td className="whitespace-nowrap px-5 py-4 font-semibold text-orange" data-id="element-156" data-mp="9jmlohvh1ftw">{row.pages}</td>
                </tr>)}
            </tbody>
          </table>
        </ScrollHintTable>

        <p className="mt-6 text-center text-sm leading-relaxed text-muted" data-id="element-157" data-mp="3vy5zaccmgqzb">
          Recibes los 6 tomos originales, los 5 bonos y los 6 NUEVOS cuadernos prácticos complementarios.
        </p>
        <p className="mt-2 text-center text-sm leading-relaxed text-muted" data-id="element-158" data-mp="3mx7q7fnbtt9v">
          Accede al material desde el enlace que recibirás por correo. Descarga los archivos, consulta el
          cuaderno adecuado para tu grupo e imprime las páginas que necesites.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-159" data-mp="1g7t7ak2sic97">
          {checks.map(check => <div key={check} className="flex items-center gap-2 text-sm text-white" data-id="element-160" data-mp="1b9j900lrqvjd">
              <CheckIcon size={16} className="text-success" data-id="element-161" data-mp="1jqa6nhulo20x" />
              {check}
            </div>)}
        </div>
      </div>
    </section>;
}